import { BigNumber } from 'ethers'

export enum UniversalRouterVersion {
  V1_2 = '1.2',
  V2_0 = '2.0',
}

export type RouterConfig = {
  address: string
  creationBlock: number
}

type ChainConfig = {
  samb: string
  routerConfigs: { [key in UniversalRouterVersion]: RouterConfig }
}

const SAMB_NOT_SUPPORTED_ON_CHAIN = '0x0000000000000000000000000000000000000000'

export const CHAIN_CONFIGS: { [key: number]: ChainConfig } = {
  // mainnet
  [16718]: {
    samb: '0x2b2d892C3fe2b4113dd7aC0D2c1882AF202FB28F',
    //TODO: update addresses
    routerConfigs: {
      [UniversalRouterVersion.V1_2]: {
        address: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
        creationBlock: 17143817,
      },
      [UniversalRouterVersion.V2_0]: {
        address: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
        creationBlock: 17143817,
      },
    },
  },
  // devnet
  [30746]: {
    //TODO: update addresses
    samb: '0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6',
    routerConfigs: {
      [UniversalRouterVersion.V1_2]: {
        address: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
        creationBlock: 8940568,
      },
      [UniversalRouterVersion.V2_0]: {
        address: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
        creationBlock: 8940568,
      },
    },
  },
  // testnet
  [22040]: {
    samb: '0x2Cf845b49e1c4E5D657fbBF36E97B7B5B7B7b74b',
    routerConfigs: {
      [UniversalRouterVersion.V1_2]: {
        address: '0xb0d6892CbC3f2dC5830cd8758FF3c16Fef5e847A',
        creationBlock: 3543575,
      },
      [UniversalRouterVersion.V2_0]: {
        address: '0xb0d6892CbC3f2dC5830cd8758FF3c16Fef5e847A', // only update here and creation block below
        creationBlock: 6898582,
      },
    },
  },
}

export const UNIVERSAL_ROUTER_ADDRESS = (version: UniversalRouterVersion, chainId: number): string => {
  if (!(chainId in CHAIN_CONFIGS)) throw new Error(`Universal Router not deployed on chain ${chainId}`)
  return CHAIN_CONFIGS[chainId].routerConfigs[version].address
}

export const UNIVERSAL_ROUTER_CREATION_BLOCK = (version: UniversalRouterVersion, chainId: number): number => {
  if (!(chainId in CHAIN_CONFIGS)) throw new Error(`Universal Router not deployed on chain ${chainId}`)
  return CHAIN_CONFIGS[chainId].routerConfigs[version].creationBlock
}

export const SAMB_ADDRESS = (chainId: number): string => {
  if (!(chainId in CHAIN_CONFIGS)) throw new Error(`Universal Router not deployed on chain ${chainId}`)

  if (CHAIN_CONFIGS[chainId].samb == SAMB_NOT_SUPPORTED_ON_CHAIN) throw new Error(`Chain ${chainId} does not have SAMB`)

  return CHAIN_CONFIGS[chainId].samb
}

export const CONTRACT_BALANCE = BigNumber.from(2).pow(255)
export const AMB_ADDRESS = '0x0000000000000000000000000000000000000000'
export const E_AMB_ADDRESS = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee'
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'
export const MAX_UINT256 = BigNumber.from(2).pow(256).sub(1)
export const MAX_UINT160 = BigNumber.from(2).pow(160).sub(1)

export const SENDER_AS_RECIPIENT = '0x0000000000000000000000000000000000000001'
export const ROUTER_AS_RECIPIENT = '0x0000000000000000000000000000000000000002'
